import { createReducer } from 'redux-create-reducer';

import {
    UPLOAD_CSV_CUSTOM_WATCHLIST,
} from '../types/uploadCsvCustomWatchlistTypes';

const initialState = {
    csvFile: [],
    isLoading: false,
};

const csvCustomWatchlistReducer = createReducer(initialState, {
    [UPLOAD_CSV_CUSTOM_WATCHLIST.DEFAULT]: (state, { payload }) => ({
        ...state,
        isLoading: true,
    }),
    [UPLOAD_CSV_CUSTOM_WATCHLIST.PENDING]: (state, { payload }) => ({
        ...state,
        isLoading: true,
    }),
    [UPLOAD_CSV_CUSTOM_WATCHLIST.REJECTED]: (state, { payload }) => ({
        ...state,
        isLoading: false,
    }),
    [UPLOAD_CSV_CUSTOM_WATCHLIST.FULFILLED]: (state, { payload }) => ({
        ...state,
        csvFile: payload.data,
        isLoading: false,
    }),
});


export default csvCustomWatchlistReducer;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/reducers/uploadCsvCustomWatchlistReducer.js